import { APIModelImpl } from '../../toolkit/uicomponentapimodel';
import { SpecificSearchToneDtoImpl } from '../../../core/dto/specificsearchtone/specificsearchtonedto';
import { SpecificSearchToneResponse } from '../../../core/api/search/specificsearchtone/specificsearchtoneresponse';
import { SpecificSearchToneRequestImpl } from '../../../core/api/search/specificsearchtone/specificsearchtonerequest';

export interface NameTunesAPIModel extends APIModelImpl
{
    getNameTunes(searchkey: string): void;
}

export class NameTunesAPIModelImpl extends APIModelImpl implements NameTunesAPIModel
{
  getNameTunes(searchkey: string): void
    {
        console.log("NAMETUNE SEARCH ########################################################4");
        let specificSearchToneDto = new SpecificSearchToneDtoImpl();
        specificSearchToneDto.setCategoryId(this.getContext().getConfigurationSettings().getProperty("NAME_TUNE_CATEGORYID")); // 1 or 697
        specificSearchToneDto.setToneId(0); //0 or 951829
        specificSearchToneDto.setPageNo(0);
        specificSearchToneDto.setPagePerCount(20);
        specificSearchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        specificSearchToneDto.setSearchKey(searchkey);

        this.getAPIProcesssorFactory().getSpecificSearchToneProcessorFactory().getSpecificSearchTone()
        .success((specificSearchToneResponse: SpecificSearchToneResponse)=>
        {
            console.log("specific search success #######NAME TUNE SPECIFIC SEARCH############: " + JSON.stringify(specificSearchToneResponse.getSpecificSearchToneDto().getToneList()));
            this.getAPIModelHandler().onSuccess(specificSearchToneResponse.getAPIFeature(), 
            specificSearchToneResponse.getDescription(), specificSearchToneResponse.getSpecificSearchToneDto().getToneList());
           
         })
        .failure((specificSearchToneResponse: SpecificSearchToneResponse)=>
         {
           this.getAPIModelHandler().onFailure(specificSearchToneResponse.getAPIFeature(), 
           specificSearchToneResponse.getDescription(), undefined);
         })
        .execute(new SpecificSearchToneRequestImpl(specificSearchToneDto));

        // let searchToneDto = new SearchToneDtoImpl();
        //     searchToneDto.setPagePerCount(20);
        //     searchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        //     searchToneDto.setSearchKey(searchkey); 
        //     searchToneDto.setCategoryId(+this.getContext().getConfigurationSettings().getProperty("NAME_TUNE_CATEGORYID"));
        //     searchToneDto.setSortBy("Order_By");
        //     searchToneDto.setAlignBy("ASC");
        //     searchToneDto.setPageNo(0);
        //     searchToneDto.setSearchLanguage(this.getContext().getUserContext().getLanguage());
    
        //     this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
        //     .getSearchTone()
        //     .success((searchToneResponse: SearchToneResponse)=>
        //     {
        //         this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
        //         searchToneResponse.getDescription(), searchToneResponse.getListOfSearchToneDtos().getListOfTones());
    
        //      })
        //     .failure((searchToneResponse : SearchToneResponse)=>
        //      {
        //        this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
        //        searchToneResponse.getDescription(), undefined);
        //      })
        //     .execute(new SearchToneRequestImpl(searchToneDto));
    }

    // addNameTuneAPI(): void
    // {
    //     console.log("NAMETUNE ##########################################################################3.1");
    //     let addNameTuneDto = new AddNameTuneDtoImpl();
    //     addNameTuneDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
    //     addNameTuneDto.setToneName("eyeur");
    //     addNameTuneDto.setLanguage(this.getContext().getUserContext().getLanguage());

    //     this.getAPIProcesssorFactory().getNameTuneProcessorFactory()
    //                  .getAddNameTuneAPIProcessor()
    //               .success((addNameTuneResponse: AddNameTuneResponse)=>
    //               {
    //                 console.log("NAMETUNE SUCCESS ######################################################3");
    //                  this.getAPIModelHandler().onSuccess(addNameTuneResponse.getAPIFeature(), 
    //                  addNameTuneResponse.getDescription(), addNameTuneResponse);
    //               })
    //               .failure((addNameTuneResponse: AddNameTuneResponse)=>
    //               {
    //                   this.getAPIModelHandler().onFailure(addNameTuneResponse.getAPIFeature(), 
    //                   addNameTuneResponse.getDescription(), undefined);
    //               })
    //               .execute(new AddNameTuneRequestImpl(addNameTuneDto));
    // }
   
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/nametunesapimodel.tsx